/*
  Lucien atelier — comparateur avant / après.
  Deux images superposées : on fait glisser (souris ou doigt) pour révéler l'une ou l'autre.
  Clavier : flèches gauche / droite sur le curseur (input range invisible mais focusable).
*/
(function () {
  function clamp(value) {
    return Math.min(100, Math.max(0, value));
  }

  function initCompare(stage) {
    if (stage.dataset.latCompareReady === 'true') return;
    stage.dataset.latCompareReady = 'true';

    const range = stage.querySelector('[data-lat-compare-range]');
    let dragging = false;

    function setPosition(percent) {
      const value = clamp(percent);
      stage.style.setProperty('--lat-pos', `${value}%`);
      if (range) range.value = String(Math.round(value));
    }

    function positionFromEvent(event) {
      const rect = stage.getBoundingClientRect();
      if (!rect.width) return;
      setPosition(((event.clientX - rect.left) / rect.width) * 100);
    }

    stage.addEventListener('pointerdown', (event) => {
      dragging = true;
      if (typeof stage.setPointerCapture === 'function') stage.setPointerCapture(event.pointerId);
      positionFromEvent(event);
    });

    stage.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      positionFromEvent(event);
    });

    const stop = () => {
      dragging = false;
    };
    stage.addEventListener('pointerup', stop);
    stage.addEventListener('pointercancel', stop);
    stage.addEventListener('lostpointercapture', stop);

    if (range) {
      range.addEventListener('input', () => setPosition(Number(range.value)));
      setPosition(Number(range.value));
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-lat-compare]').forEach(initCompare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
